import React, { useState } from "react";
import {
  EditPageContainer,
  Page,
  withServerErrors,
  required,
} from "components/common";
import { FormGroup, InputGroup, SaveButton } from "components/common/Forms";
import GetBack from "components/refactoring/BackButton";
import { compose, withState, withHandlers, lifecycle } from "recompose";
import qs from "query-string";
import { LocalForm, Control, actions } from "react-redux-form";
import { Trans } from "react-i18next";
import { useHistory } from "react-router-dom";
import { Col, Row } from "reactstrap";
import {DatePicker} from "components/common";
import Select from "react-select";
import { colStyle } from "../CoreComponents";

export const PromocodeEdit = ({
  t,
  mode,
  item,
  form,
  setDispatch,
  onSubmit: onSubmitProp,
  onUpdate,
  onChange,
  readOnly,
}) => {
  // const { organisationsQuery } = useOrganisationContext();

  const history = useHistory();

  async function onSubmit(...args) {
    await onSubmitProp(...args);
    // await organisationsQuery.refetch();
    setTimeout(() => {
      history.push(`/core/promocode`);
    }, 1500);
  }

  const [selectedOption, setSelectedOption] = useState()

  const handleTypeChange = (selectedValue) => {
    setSelectedOption(selectedValue);
  };

  const percentOrPrice = [
    {value: "Percent", label: t("Percentage")},
    {value: "Price value", label: t("Price value")},
  ]

  const suffix = selectedOption === "Price value" ? "SAR" : "%"

  return (
    <Page title={`${mode} Promo Code`}>
      <GetBack styleClass="my-2"/>
      <LocalForm
        initialState={item}
        onSubmit={onSubmit}
        getDispatch={setDispatch}
        onUpdate={onUpdate}
        onChange={onChange}
        validators={{
            discount: { required },

        }}>
        <div className="d-flex justify-content-start">
        <Row style={{maxWidth:"50%"}}>
        {item && item?.code && 
          <Col {...colStyle}>
            <FormGroup label="Promo Code*">
              <Control.text disabled model=".placeholder" placeholder={item?.code}/>
            </FormGroup>
          </Col>
        }
        <Col {...colStyle}>
          <FormGroup label="Code Type *" model=".code_type" addControlClass={false}>
            <Control.text
              style={{ backgroundColor: '#F4F7FE' }}
              model=".code_type"
              component={Select}
              options={percentOrPrice}
              simpleValue
              clearable={false}
              placeholder={t(`Select Type`)}
              disabled
              defaultValue="Percent"
              onChange={(selectedValue) => handleTypeChange(selectedValue)}
            />
          </FormGroup>
        </Col>

        <Col {...colStyle}>
          <FormGroup label="Discount*" model=".discount">
            <InputGroup suffixText={suffix}>
              <Control.text model=".discount" />
            </InputGroup>
          </FormGroup>
        </Col>

        <Col {...colStyle}>
          <FormGroup label="Expiry Date *" model=".expiry_date">
            <DatePicker model=".expiry_date" className="form-control"/>
          </FormGroup>
        </Col>

        <Col {...colStyle}>
          <div className="my-3">
            <Control.checkbox model=".active"  /> <Trans>Activate</Trans>
          </div>
        </Col>
        </Row>
        <div className="ml-5 mt-2">
          {item && item?.get_image &&
            <img src={"/api" + item.get_image} style={{maxWidth:300}}/>
          }
        </div>
        </div>

        <div className="my-3 d-flex justify-content-start">
          <SaveButton className="px-3 m-0" form={form} hidden={readOnly} />
        </div>

      </LocalForm>
    </Page>
  );
};

const enhance = compose(
  withServerErrors(),
  EditPageContainer({
    url: "core/hesaab-promo-code",
  }),
  withState("serverErrors", "setServerErrors", {}),
  withState("redirectUrl", "setRedirectUrl", null),
  withHandlers({
  }),
  lifecycle({
    componentDidMount() {
      Promise.resolve().then(() => {
        const q = qs.parse(this.props.location.search);
        if (q.oauth_verifier && q.oauth_token && q.org)
          this.props.verify(q.oauth_token, q.oauth_verifier, q.org);
      });
    },
  })
);

export default enhance(PromocodeEdit);
